/*======= FIXED HEADER ==========*/
$(document).ready(function () {
	var header = $('header');
	var jsFixedHeader = $('#JSfixed_header');
	var offsetTop, offsetBottom;
	var isSticky = false;
	var rafScheduled = false;

	function updateOffsets() {
		offsetTop = header.offset().top;
		offsetBottom = offsetTop + header.outerHeight(true);
	}

	function applyStickyHeader() {
		var scrollTop = window.scrollY || window.pageYOffset;
		var shouldBeSticky = scrollTop >= offsetBottom;

		if (shouldBeSticky !== isSticky) {
			isSticky = shouldBeSticky;
			jsFixedHeader.toggleClass('JSsticky_header', isSticky);
		}

		rafScheduled = false;
	}

	function handleScroll() {
		if (!rafScheduled) {
			rafScheduled = true;
			requestAnimationFrame(applyStickyHeader);
		}
	}

	var resizeTimeout;
	function handleResize() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			updateOffsets();
			applyStickyHeader();
		}, 150);
	}

	updateOffsets();
	applyStickyHeader();

	$(window).on('scroll', handleScroll);
	$(window).on('resize', handleResize);
});